(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function(sectionId) {
  var selector = sectionId
    ? '.product-recommendations[data-section-id="' + sectionId + '"]'
    : '.product-recommendations';

  var productRecommendationsSection = document.querySelector(selector);
  if (productRecommendationsSection === null) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      var incoming = container.querySelector(selector) || container.querySelector(".product-recommendations");
      if (!incoming) { return; }

      productRecommendationsSection.innerHTML = incoming.innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('.product-recommendations[data-section-id="' + event.detail.sectionId + '"]')) {
    loadProductRecommendationsIntoSection(event.detail.sectionId);
  }
});

loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
